/**
 * Default Theme of Chakra is modified here to fit the Figma design.
 *
 * @remarks
 * please don't add colours or modifications unless they fit globally.
 */

import { extendTheme } from "@chakra-ui/react";

const HJSTheme = extendTheme({
  fonts: {
    body: "'Manrope', sans-serif",
  },
  colors: {
    hjsAiScore: "#E4E400",
    hjsPreferenceScore: "#009BF2",
    hjsBlack: "#272727",
    hjsFooterBlack: "#0C0C0C",
    hjsPrimaryLight: "#d69e2e80",
    hjsPrimaryHover: "#BF8E2B",
    hjsSecondaryHover: "#2B6061",
    hjsSurveyComplete: "#A7A7A7",
    hjsSliderTrack: "#90B5B9",
    hjsOpaqueBlackAlpha: "#F5F5F5",
    primaryGreen: "#E6FFFA",
    primaryGold: "#D69E2E",
    primaryThemeColor: "#2C7A7B",
  },
  breakpoints: {
    sm: "320px",
    md: "768px",
    lg: "960px",
    "2lg": "1024px",
    xl: "1200px",
    "2xl": "1536px",
    "3xl": "2000px",
    "3xl1": "2300px",
  },
});

export default HJSTheme;
